import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import CardLaboratory from "../../atoms/cardLaboratory/cardLaboratory";
import LaboratoriesSlider from "../../molecules/laboratoriesSlider/laboratoriesSlider";

import "./laboratoryRotator.scss";

const LaboratoryRotator = (props: ReferenciaContenido) => {
  let labs = Array();

  for (let i = 0; i < props.referenciaPlantillaContenido.length; i++) {
    let newLab = Object();
    newLab.nombreCategoria = props.nombreCategoria;
    newLab.tituloGeneral = props.tituloGeneral;
    newLab.titleDescription =
      props.referenciaPlantillaContenido[i].tituloDescripcion;
    newLab.description = props.referenciaPlantillaContenido[i].descripcion;
    newLab.titleBanner = props.referenciaPlantillaContenido[i].tituloBanner;
    newLab.typeTitle = props.referenciaPlantillaContenido[i].tipoTitulo;
    newLab.bottonRedirect =
      props.referenciaPlantillaContenido[i].redireccionBoton;
    newLab.imgUrl = props.referenciaPlantillaContenido[i].imagenPrincipal;

    labs.push(newLab);
  }

  labs = labs.slice(0, 6);

  return (
    <div className="o-laboratory-rotator">
      {/*<div className='o-laboratory-rotator__button'>
                <Button 
                type='link' 
                isDisabled={false} 
                text='VER TODO' 
                classname='o-laboratory-rotator__button-btn'
                href={props.redireccionBoton}
                gtmMark={`gtm${normalizeTwoWords(props.nombreCategoria)}${
                    normalizeTwoWords(props.tituloGeneral)}${
                    normalizeTwoWords(props.tituloBoton)}`
                }
                />
            </div>*/}

      <div className="o-laboratory-rotator__background">
        <h2 className="o-laboratory-rotator__background-title">
          {props.tituloGeneral}
        </h2>

        <div className="o-laboratory-rotator__background-description">
          {documentToReactComponents(props.descripcion.json)}
        </div>
      </div>

      <div className="o-laboratory-rotator__slider">
        <div className="o-laboratory-rotator__slider-faded"></div>
        <LaboratoriesSlider laboratories={labs} />
      </div>

      <div className="o-laboratory-rotator__mobile">
        <p className="o-laboratory-rotator__mobile-title">
          {props.tituloGeneral}
        </p>

        <div className="o-laboratory-rotator__mobile-description">
          {documentToReactComponents(props.descripcion.json)}
        </div>

        <div className="o-laboratory-rotator__mobile-labs">
          {labs
            .filter((lab, idx) => (idx <= 2 && lab.description?.json))
            .map((lab, idx) => {
              return (
                <CardLaboratory
                  titleDescription={lab.titleDescription}
                  titleBanner={lab.titleBanner}
                  description={lab.description?.json}
                  typeTitle={lab.typeTitle}
                  imgUrl={lab?.imgUrl && lab.imgUrl[0]}
                  bottonRedirect={lab.bottonRedirect}
                  nombreCategoria={props.nombreCategoria}
                  tituloGeneral={props.tituloGeneral}
                  key={idx}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default LaboratoryRotator;
